import { GameState as Blackjack2GameState } from '@/models/games/blackjack2/enums/GameState';
import { GameState } from '@/models/games/enums/GameState';
import { GameType } from '@/models/games/enums/GameType';
import { getHostById } from '@/modules/host/slice';
import { getHostLiveDataByHostId } from '@/modules/hostLive/slice';
import { RootState } from '@/store/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useIsBettingInfo = (hostId: number, gameType: GameType) => {
    const { IsRest, IsPause, HostMessageId } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const { CurrentResult, CurrentState } = useSelector((state: RootState) =>
        getHostLiveDataByHostId(state, hostId)
    );
    const isBetting = useMemo(
        () =>
            IsRest
                ? false
                : CurrentState === GameState.Betting ||
                  (gameType == GameType.Blackjack2 &&
                      CurrentState === Blackjack2GameState.Ready),
        [IsRest, CurrentState, gameType]
    );
    const isShuffling = useMemo(
        () => CurrentResult?.GameCount === 0,
        [CurrentResult]
    );
    // useEffect(() => {
    //     console.log('???? CurrentState', CurrentState, gameType);
    // }, [CurrentState]);

    return {
        isBetting,
        isShuffling,
        CurrentResult,
        IsRest,
        IsPause,
        HostMessageId,
    };
};
